import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-main-tools',
  templateUrl: './mobile-main-tools.component.html',
  styleUrls: ['./mobile-main-tools.component.scss']
})
export class MobileMainToolsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
